<template>
    <div class="page-container">
        <div class="data-container">
            <el-form class="search-form" ref="search_form" :inline="true" :model="queryForms" label-position="top">
                <el-form-item label="文件名称">
                    <el-input v-model="queryForms.name" style="width: 160px" clearable placeholder="请输入文件名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="getListData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="display: flex; margin-bottom: 10px">
                <el-button type="primary" :icon="Plus" @click="onAddClick">添加</el-button>
                <div class="card-header" style="margin-left: auto">
                    <div class="circle-btn">
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="formVisible ? '隐藏搜索' : '显示搜索'"
                            placement="top"
                        >
                            <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                            <el-button plain circle @click="getListData" :icon="Refresh" size="small"></el-button>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <el-table
                ref="multipleSelection"
                :data="tableListsData"
                :row-key="(row) => row.id"
                height="calc(100vh - 330px)"
                @selection-change="handleSelectionChange"
                border
                style="width: 100%"
                v-loading="tableLoading"
                :header-cell-style="{ textAlign: 'center' }"
                stripe
            >
                <el-table-column label="序号" align="center" width="60" type="index" />
                <el-table-column label="名称" align="center" prop="name" show-overflow-tooltip></el-table-column>
                <el-table-column label="版本号" align="center" prop="version" show-overflow-tooltip></el-table-column>
                <el-table-column
                    label="更新时间"
                    prop="update_time"
                    width="170"
                    align="center"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="240">
                    <template #default="{ row }">
                        <!-- <el-button type="primary" link :icon="View" size="small" @click="onShowClick(row)">详情</el-button> -->
                        <el-button type="primary" link :icon="Edit" size="small" @click="onEditClick(row)">编辑</el-button>
                        <el-button type="primary" link :icon="Delete" size="small" @click="onRemoveClick(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <Pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForms.page"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="queryForms.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            />
        </div>
        <forms-dialog
            v-if="formDialogVisible"
            v-model="formDialogVisible"
            :isForm="isForm"
            :upgradeDetail="selectUpgrade"
            @updateForm="getListData"
        ></forms-dialog>
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { Plus, View, Edit, Delete, Search, Refresh } from '@element-plus/icons-vue'
import { getUpgradeFileList, deleteUpgradeFileApi } from '@/api/thermostat/devicePoint.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import FormsDialog from './components/forms.vue'
import Pagination from '@/components/Pagination/index.vue'

// 重置
const resetQueryForm = () => {
    Object.keys(queryForms.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size' && key !== 'chapter' && key !== 'knowledge' && key !== 'subject') {
            queryForms.value[key] = ''
        }
    })
    getListData()
}

const formVisible = ref(true)
const queryForms = ref({
    name: '',
    page: 1,
    page_size: 10
})

const total = ref(0)

// 获取列表数据
const tableLoading = ref(false)
const tableListsData = ref([])
const getListData = async () => {
    tableLoading.value = true
    const res = await getUpgradeFileList(queryForms.value)
    // tableListsData.value = res.lists
    tableListsData.value = res.lists
    total.value = res.total
    tableLoading.value = false
}
// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    getListData()
}
// page 页码改变触发
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getListData()
}
const formDialogVisible = ref(false)
const isForm = ref(false)
const selectUpgrade = ref({})
// 添加资源
const onAddClick = () => {
    isForm.value = true
    selectUpgrade.value = ''
    formDialogVisible.value = true
}

// 详情
const onShowClick = (row) => {
    isForm.value = false
    selectUpgrade.value = row
    formDialogVisible.value = true
}
// 编辑
const onEditClick = (row) => {
    isForm.value = true
    selectUpgrade.value = row
    formDialogVisible.value = true
}
// 删除
const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定删除吗？', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
    })
        .then(async () => {
            await deleteUpgradeFileApi(row.id)
            ElMessage.success('操作成功')
            // 重新渲染数据
            getListData()
        })
        .catch(() => {})
}
const multipleSelection = ref()
const selectedCoursewareList = ref([])
const handleSelectionChange = (val) => {
    selectedCoursewareList.value = val
}

onMounted(() => {
    getListData()
})
</script>

<style lang="scss" scoped>
.upgradeContainer {
    width: 100%;
    background-color: #fff;
}
.tree-index {
    display: inline-block;
    margin-right: 5px;
}
.table-box,
.table-main {
    height: 100%;
    padding: 10px 10px;
}

.pagination {
    margin: 10px 0;
}
</style>
